export default __webpack_public_path__ + "static/media/close-icon.f817ba7d.svg";